import { Hiring } from './Hiring';
export { Hiring };
export default Hiring;
